import { NgModule } from '@angular/core';
import { savedCartTranslationChunksConfig, savedCartTranslationsEn } from "@spartacus/cart/saved-cart/assets";
import { CART_SAVED_CART_FEATURE, SavedCartRootModule } from "@spartacus/cart/saved-cart/root";
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";

@NgModule({
  declarations: [],
  imports: [
    SavedCartRootModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_SAVED_CART_FEATURE]: {
          module: () =>
            import('./saved-cart.module').then((m) => m.GenSavedCartModule),
        },
      }
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: savedCartTranslationsEn },
        chunks: savedCartTranslationChunksConfig,
      },
    }),
  ]
})
export class GenCartSavedCartFeatureModule {
}
